<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<section class="main-content first">
			<div class="row">
				<div class="columns column12">
					<picture>
						<source v-if="page.overviewImageWebp" :srcset="page.overviewImageWebp" type="image/webp" />
						<source :srcset="page.overviewImage" />
						<img loading="lazy" :src="page.overviewImage" :alt="page.overviewImageAlt" />
					</picture>
					<h1>{{ page.title || page.header }}</h1>
					<strong v-if="page.date" class="date">
						{{ $d(new Date(page.date.date.split(' ')[0]), 'short') }}
					</strong>
					<div v-parse-links v-html="page.content" />
				</div>
			</div>
		</section>

		<section class="main-content background-color">
			<div class="row">
				<div class="columns column12 align-center">
					<h2>{{ $t('moreNews') }}</h2>
				</div>
			</div>
			<div id="news-container" class="row news promotions-row">
				<div v-if="other" class="columns column12 item">
					<div class="news-block">
						<div class="news-image left">
							<nuxt-link :to="localePath(`/${other.filename}`)">
								<picture>
									<source
										v-if="other.overviewImageWebp"
										:srcset="other.overviewImageWebp"
										type="image/webp"
									/>
									<source :srcset="other.overviewImage" />
									<img loading="lazy" :src="other.overviewImage" :alt="other.overviewImageAlt" />
								</picture>
							</nuxt-link>
						</div>
						<div class="news-content left">
							<h3>{{ other.title || other.header }}</h3>
							<p>
								<strong>
									{{ $d(new Date(other.date.date.split(' ')[0]), 'short') }}
								</strong>
							</p>
							<div v-parse-links v-html="other.overviewContent" />
							<nuxt-link class="button button-no-fill" :to="localePath(`/${other.filename}`)">
								{{ $t('readMore') }}
							</nuxt-link>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="columns column12 align-center">
					<nuxt-link class="button button-no-fill" :to="localePath('news')">
						{{ $t('allNews') }}
					</nuxt-link>
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();

const { data: news } = await useWebsiteFetch('news', {
	query: { language: locale.value },
	key: `${locale.value}/news`,
});

const other = news.value.find((newsPage) => newsPage.pageID !== page.value.pageID);
</script>

<style lang="scss" scoped>
img {
	display: block;
	max-width: 300px;
	margin: 0 0 40px;
}

.date {
	margin: 0 0 10px;
	font-size: 13px;
	font-weight: 700;
	display: inline-block;
	letter-spacing: 2px;
}
</style>
